export const Configuration = {
  useMock: false,
  supportedLanguages: ["en"]
};
